import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StandardDropdown from '@wix/da-shared-react/pkg/Dropdown/Preset/StandardDropdown';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { PostsSortOrder } from '../../../../../../types/posts';

import s from './SortOrderSwitcher.scss';

interface Props {
  value: PostsSortOrder;
  onChange: (value: PostsSortOrder) => void;
  className?: string;
}

enum sortOrderBiValue {
  NEWEST = 'newest',
  OLDEST = 'oldest',
}

const sortOrderBi = {
  [PostsSortOrder.NEWEST]: sortOrderBiValue.NEWEST,
  [PostsSortOrder.OLDEST]: sortOrderBiValue.OLDEST,
};

const SortOrderSwitcher: React.FC<Props> = ({ value, onChange, className }) => {
  const { t } = useTranslation();
  const items = useMemo(
    () => [
      {
        value: PostsSortOrder.NEWEST,
        label: t('common.sortOrder.newest'),
        biData: {
          evid: BiEventType.FEED_SORT_ORDER_SELECT,
          sort_order: sortOrderBi[PostsSortOrder.NEWEST],
        },
      },
      {
        value: PostsSortOrder.OLDEST,
        label: t('common.sortOrder.oldest'),
        biData: {
          evid: BiEventType.FEED_SORT_ORDER_SELECT,
          sort_order: sortOrderBi[PostsSortOrder.OLDEST],
        },
      },
    ],
    [t]
  );

  return (
    <StandardDropdown
      role="menu"
      className={className}
      toggleClassName={s['toggle']}
      arrowClassName={s['arrow']}
      placement="bottom-start"
      selectedValue={value}
      onSelect={onChange}
      items={items}
    />
  );
};
SortOrderSwitcher.displayName = 'SortOrderSwitcher';
export default SortOrderSwitcher;
